import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Page from '../../../templates/page'
import Footer from '../../../common/footer'
import FaqSection from './section'

import { FaqTexts } from './types'

const Faq: React.FunctionComponent = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })
    
    const { t, i18n } = useTranslation('faq')
    const language = i18n.language

    const faq: FaqTexts = i18n.getResourceBundle(language, 'faq')

    return (
        <Page hideSocial invertedLogo name={'faq'}>
            <Container>
                <Title>{t('title')}</Title>
                { faq.sections.map((s, i) => <FaqSection key={i} { ...s} />) }
            </Container>
            <Footer />
        </Page>
    )
}

const Container = styled.div`
    width: 100%;

    display: grid;
    grid-template-columns: 1fr;

    align-items: flex-start;
    justify-items: flex-start;

    padding: 100px 20px;

    ${up('tablet')} {
        padding: 100px 32px;
    }

    ${up('desktop')} {
        padding: 100px 80px;
    }
`

const Title = styled.h1`
    margin: 0;
    margin-bottom: 32px;

    font-size: 30px;
    font-weight: 700;
`

export default Faq